
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document"  *ngIf="districtEntityName" >
    <!-- <div class="popupstarting"> -->
      <div class="modal-content" style="border-radius: 30px;" data-backdrop="static" data-keyboard="false">
        <div class="modal-body">
          <div class="d-flex">
            <svg xmlns="http://www.w3.org/2000/svg" class="caution" width="24" height="24" viewBox="0 0 24 24"><path d="M12 1l-12 22h24l-12-22zm-1 8h2v7h-2v-7zm1 11.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"/></svg>
            <p >
              Dear Sir/Madam,<br>
              In the next meeting of Distric Ganga Committee you all are requested to discuss on the mapping of Nala and share the details with NMCG at the earliest.<br><br>
               As On {{date | date:'dd/MM/yyyy'}}, You need to conduct your pending ({{popupObj}}) monthly meeting and Upload the corresponding month’s attendance and minutes of meeting. <br> 
              <b>click on to proceed further.</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
               <a (click)="defaultRoute()" type="button" class="btn btn-primary"
               data-toggle="tooltip" title="Submit  Data" data-placement="bottom" data-original-title="Submit Data"><i
                 class="fa fa-edit" aria-hidden="true" name="submitdata"></i></a>
            </p>
            <button type="button" (click)="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  <!-- </div> -->


  <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="margin: 0px;" *ngIf="validateEntityName">
    <div class="modal-content" style="border-radius: 30px;">
      <div class="modal-body">
        <div class="d-flex">
          <svg xmlns="http://www.w3.org/2000/svg" class="caution" width="24" height="24" viewBox="0 0 24 24"><path d="M12 1l-12 22h24l-12-22zm-1 8h2v7h-2v-7zm1 11.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"/></svg>
          <p >
            Dear Sir/Madam,<br>
             As On {{date | date:'dd/MM/yyyy'}}, You need to conduct your pending ({{popupObj}}) monthly meeting and Upload the corresponding month’s attendance and minutes of meeting.<br><br>
             <b>click on the icon to proceed further and validate.</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             <a (click)="gotoDefaultRoute()" type="button" class="btn btn-primary"
             data-toggle="tooltip" title="Submit  Data" data-placement="bottom" data-original-title="Submit Data"><i
               class="fa fa-edit" aria-hidden="true" name="submitdata"></i></a>
          </p>
          <button type="button" (click)="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="margin: 0px;" *ngIf="stateEntityName">
    <div class="modal-content" style="border-radius: 30px;">
      <div class="modal-body">
        <div class="d-flex">
          <svg xmlns="http://www.w3.org/2000/svg" class="caution" width="24" height="24" viewBox="0 0 24 24"><path d="M12 1l-12 22h24l-12-22zm-1 8h2v7h-2v-7zm1 11.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"/></svg>
          <p >
            Dear Sir/Madam,<br>
            In the next meeting of Distric Ganga Committee you all are requested to discuss on the mapping of Nala and share the details with NMCG at the earliest.<br><br>
             As On {{date | date:'dd/MM/yyyy'}},{{statependingData}} meeting reports are pending for the year {{currentYear}} .For more details click on this <a href="javascript:void(0)" (click)="gotoRoute()">link</a> and know more by selecting the required year and month you want to know about.
          </p>
          <button type="button" (click)="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="margin: 0px;" *ngIf="adminEntityName">
    <div class="modal-content" style="border-radius: 30px;">
      <div class="modal-body">
        <div class="d-flex">
          <svg xmlns="http://www.w3.org/2000/svg" class="caution" width="24" height="24" viewBox="0 0 24 24"><path d="M12 1l-12 22h24l-12-22zm-1 8h2v7h-2v-7zm1 11.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"/></svg>
          <p >
            Dear Sir/Madam,<br>
            In the next meeting of Distric Ganga Committee you all are requested to discuss on the mapping of Nala and share the details with NMCG at the earliest.<br><br>
             As On {{date | date:'dd/MM/yyyy'}},{{statependingData}} meeting reports are pending for the year {{currentYear}} .For more details click on this <a  href="javascript:void(0)" (click)="gotoRoute()">link</a> and know more by selecting the required year and month you want to know about.
          </p>
          <button type="button" (click)="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="margin: 0px;" *ngIf="viewAdminEntityName">
    <div class="modal-content" style="border-radius: 30px;">
      <div class="modal-body">
        <div class="d-flex">
          <svg xmlns="http://www.w3.org/2000/svg" class="caution" width="24" height="24" viewBox="0 0 24 24"><path d="M12 1l-12 22h24l-12-22zm-1 8h2v7h-2v-7zm1 11.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"/></svg>
          <p >
            Dear Sir/Madam,<br>
            In the next meeting of Distric Ganga Committee you all are requested to discuss on the mapping of Nala and share the details with NMCG at the earliest.<br><br>
             As On {{date | date:'dd/MM/yyyy'}},{{statependingData}} meeting reports are pending for the year {{currentYear}} .For more details click on this <a  href="javascript:void(0)" (click)="gotoRoute()">link</a> and know more by selecting the required year and month you want to know about.
          </p>
          <button type="button" (click)="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>